import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiImage } from '@elastic/eui';
import styled from 'styled-components';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import patent2image2 from '../../documents/patent2image2.JPG'

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
class Patent2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            patent2objective: "Deployment of Hybrid GAN model for generating concrete mix database",
            patent2Key: ['Industry 4.0 C (C- Civil, Concrete, Construction)', 'Hybrid Generative Adversarial Network', 'Data augmentation and generation of concrete mix', 'Hybrid GAN for regression problem', '5+ Patent claims', 'Mobile Application is user defined'],
            patent2Value: ['Innovation','Concept Development','Inter-disciplinary Engineering']
            }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                        <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>Concrete GAN: Hybrid GAN Approach for Data Augmentation and Generation 
                        </font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h5><font face='Segoe UI'>Mentor :- Dr. Hemant Dhonde 
                        &emsp; &emsp; &emsp; &emsp; &emsp;
                        &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp;
                        &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp;
                        &emsp; &emsp; &emsp;  August 2020 – Present</font></h5></EuiText>
                        <EuiSpacer size='m' />
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                        <EuiText>
                        <b>Research Objectives</b><br/>
                        {this.state.patent2objective}<EuiSpacer/>
                        <b>Key Highlights</b> 
                        <StyledText><ul className="skills-list">
                        {this.state.patent2Key && this.state.patent2Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions</b>
                        <StyledText><ul className="skills-list">
                        {this.state.patent2Value && this.state.patent2Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText></EuiText>
                </EuiFlexItem><EuiFlexItem grow={false}><EuiText textAlign='center'><EuiImage size='m' src={patent2image2} /><EuiSpacer size = 's'/></EuiText></EuiFlexItem>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Patent2 }